import { __extends } from "tslib";
import { listApps, configureApps, } from '@wix/ambassador-social-groups-v1-group-app/http';
import { BaseApi } from '../BaseApi';
var GroupAppsApi = /** @class */ (function (_super) {
    __extends(GroupAppsApi, _super);
    function GroupAppsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupAppsApi.prototype.getGroupApps = function (groupId) {
        return this.getHTTPClient().request(listApps({
            groupId: groupId,
        })); // TODO: add types
    };
    GroupAppsApi.prototype.configureApps = function (groupId, apps) {
        return this.getHTTPClient().request(configureApps({
            groupId: groupId,
            apps: apps,
        }));
    };
    return GroupAppsApi;
}(BaseApi));
export { GroupAppsApi };
//# sourceMappingURL=GroupAppsApi.js.map